export namespace RepayLoanConst {
  export enum RepayFor {
    REPAYAPL = 'REPAYAPL',
    REPAYOPL = 'REPAYOPL',
    REPAY_OPL_APL = 'REPAY_OPL_APL'
  }
}
